import styled, { css } from "styled-components";

interface IMyGroupsDropdownContainerProps {
  showDropdown: boolean;
}

export const MyGroupsDropdownContainer = styled.button<IMyGroupsDropdownContainerProps>`
  padding: 0.75rem 0;

  background-color: ${({ theme }) =>
    theme.classwork.imersive.bluredBackgroundColor};
  border: 1px solid
    ${({ theme }) => theme.classwork.imersive.dropdownBorderColor};

  backdrop-filter: blur(10px);

  border-radius: 4px;

  width: 100%;

  :hover {
    cursor: pointer;
  }

  .texts {
    padding: 0 0.75rem;
  }

  .title {
    font: 600 0.875rem/1.3125rem "Inter";
    color: ${({ theme }) => theme.classwork.imersive.dropdownTitle};

    display: flex;
    align-items: center;
    gap: 0.25rem;

    span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 20ch;
    }

    svg {
      transition: 0.3s all;

      min-width: 20px;
      min-height: 20px;
    }
  }

  .members-count {
    font: 500 0.75rem/1.125rem "Inter";
    color: ${({ theme }) => (theme.mode === "dark" ? "#c5c1ca" : "#565656")};

    margin-top: 0.25rem;

    text-align: start;
  }

  .dropdown-content {
    max-height: 0px;
    overflow: hidden;

    transition: 0.3s all;

    :has(.loader) {
      overflow: initial;
    }
  }

  ${({ showDropdown }) =>
    showDropdown &&
    css`
      .dropdown-content {
        max-height: 400px;
        overflow: auto;

        margin-top: 1rem;
      }

      .title svg {
        transform: rotate(180deg);
      }
    `}
`;
